export const API_URL = 'https://sheltered-thicket-07747.herokuapp.com'
export const GOOGLE_KEY = "AIzaSyABuDWRbcFNQAOPdwZqBgxpqYYthhJoszY"
export const header = {
    who_are_we: 'من نحن',
    contactus: 'اتصل بنا',
    landing_page: 'الصفحة الرئيسية',
    rdv: 'موعد',
    action: 'تتبع الملف'
}

export const about_us = {
    title: 'من نحن',
    text: "نقدم خدماتنا في مجال تحصيل الديون بأعلى معايير الجودة ننهج في عملنا الأسلوب العملي في أعمالنا ونصقله بخبراتنا الإدارية و نطوره ونستقطب أفضل الكوادر البشرية لنكون مجموعة عمل متكاملة من ذو الخبرات في عدة مجالات واستحدثنا أقساما متخصصة وفعلنا أنظمة تشغيل وإدارة متقدمة لتحقيق أفضل النتائج لنصبح رواد في مجال تحصيل الديون و الخيار الأول لعملائنا في إدارة وتحصيل الديون."

}

export const services ={
    title : 'خدماتنا',
    action:'اتصل بنا الآن'
}
export const tes_timonial = {
    title: 'شهادة العملاء'
}
export const modal_rdv = {
    rdv: 'احجز موعد'
}
export const road = {
    title: 'خريطة الموقع',
    block1: {
        title: '  معلومات ',
        links: [
            'الصفحة الرئيسية',
            'من نحن',
            
            'أسئلة و أجوبة'
        ]
    },
    block2: {
        title: ' خدمات ',
        links: [
            'اتصل بنا',
            'موعد',
            'تتبع الملف'
        ]
    }
}


export const footer = {
    copyright: 'كل الحقوق محفوظة © 2020',
}

// forms
export const contact = {
    title: 'تواصل معنا',
    f1 :'الاسم الكامل',
    f2:'البريد الإلكتروني',
    f3:'رقم الهاتف',
    f4:'متطلبات الموقع الإلكتروني',
    action : 'إرسال'
}

export const login ={
    usernamee :{
        title: 'البريد الالكتروني',
        placeholder:'أدخل البريد الإلكتروني'
    },
    passwrd: {
        title: 'كلمة المرور',
        placeholder:'أدخل كلمة المرور'
    },
    action:{
        login: 'تسجيل الدخول'
    }
}

export  const front_text ={
    title :  "مكتب تحصيل الديون" +
        "<br>Cabinet du Recouvrement de Créances",

    text : "لسنا الوحيدين لكننا الافضل"
}